import convertToDayjs from "./convertToDayjs";

const convertToDayjsIfDate = (date) => date && convertToDayjs(date);

export default convertToDayjsIfDate;
